jQuery(document).ready(function() {

    jQuery('#table_user').DataTable();
    jQuery('#table_user1').DataTable();

    jQuery(".tabs-list li a").click(function(e) {
        e.preventDefault();
    });
    jQuery(".tabs-list li").click(function() {
        var tabid = jQuery(this).find("a").attr("href");
        jQuery(".tabs-list li,.tabs div.tab").removeClass("active"); // removing active class from tab

        jQuery(".tab").hide(); // hiding open tab
        jQuery(tabid).show(); // show tab
        jQuery(this).addClass("active"); //  adding active class to clicked tab
    });

    jQuery(".tabs-list-follower li a").click(function(e) {
        e.preventDefault();
    });
    jQuery(".tabs-list-follower li").click(function() {
        var tabid = jQuery(this).find("a").attr("href");
        jQuery(".tabs-list-follower li,.tabs-follower div.tab-follower").removeClass("active"); // removing active class from tab

        jQuery(".tab-follower").hide(); // hiding open tab
        jQuery(tabid).show(); // show tab
        jQuery(this).addClass("active"); //  adding active class to clicked tab
    });
});